import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlanneConciergeLogoWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1298.6399999999999 378",
	width: 1298.6399999999999,
	height: 378,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6.72,
			y: 6.72,
			width: 364.56,
			height: 364.56,
			rx: 74.28,
			fill: "none",
			stroke: "#FFFFFF",
			strokeWidth: 13.44
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(123.5 90.7) scale(8.1900)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#FFFFFF",
				fillRule: "nonzero",
				d: "M 2.224 24 L 2.223 20.506 L 0.011 21.886 L 0 0 L 15.908 9.204 L 13.342 10.692 L 15.995 12.228 L 9.114 16.22 L 7.656 17.115 L 5.288 18.593 L 5.288 22.059 L 2.224 24 Z M 3.109 19.953 L 3.11 22.388 L 4.405 21.567 L 4.405 19.144 L 3.109 19.953 Z M 0.887 1.539 L 0.891 9.213 L 0.896 20.286 L 2.223 19.458 L 2.22 12.235 L 2.215 4.253 L 12.457 10.179 L 14.137 9.204 L 0.887 1.539 Z M 3.102 5.793 L 3.106 12.235 L 3.108 18.906 L 4.404 18.098 L 4.404 10.67 L 4.402 8.092 L 8.852 10.667 L 6.635 11.954 L 5.289 12.797 L 5.289 14.41 L 7.516 13.045 L 11.57 10.693 L 3.102 5.793 Z M 5.29 15.451 L 5.29 17.544 L 7.193 16.357 L 8.668 15.452 L 14.225 12.228 L 12.458 11.205 L 7.965 13.812 L 5.29 15.451 Z M 5.289 9.632 L 5.29 11.749 L 6.186 11.188 L 7.081 10.669 L 5.289 9.632 Z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(458.64 78.0) scale(9.9790)",
			fill: "#FFFFFF",
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M 12.95 0.706 C 12.484 0.235 11.921 0 11.261 0 L 0.001 0 L 0.001 1.373 L 10.895 1.373 C 11.177 1.373 11.419 1.472 11.622 1.671 C 11.82 1.874 11.919 2.115 11.919 2.395 C 11.919 2.679 11.82 2.922 11.622 3.125 C 11.419 3.324 11.177 3.424 10.895 3.424 L 0 3.424 L 0 8.945 L 1.479 8.945 L 1.479 4.796 L 11.26 4.796 C 11.921 4.796 12.484 4.561 12.949 4.09 C 13.418 3.623 13.653 3.058 13.653 2.395 C 13.654 1.736 13.419 1.174 12.95 0.706 Z" }),
				/* @__PURE__ */ _jsx("path", {
					transform: "translate(15.582 0.019)",
					d: "M 0 0 L 1.531 0 L 1.531 7.423 L 10.651 7.423 L 10.651 8.892 L 0 8.892 L 0 0 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					transform: "translate(28.245 0.026)",
					d: "M 0 8.892 L 6.664 0 L 7.796 0 L 14.793 8.892 L 12.929 8.892 L 7.33 1.803 L 1.997 8.892 L 0 8.892 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					transform: "translate(44.967 0.019)",
					d: "M 0 8.968 L 0 0 L 1.693 0 L 10.495 7.202 L 10.495 0 L 12.052 0 L 12.052 8.9 L 10.291 8.9 L 1.49 1.698 L 1.49 8.968 L 0 8.968 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					transform: "translate(59.051 0.019)",
					d: "M 0 8.968 L 0 0 L 1.692 0 L 10.494 7.202 L 10.494 0 L 12.051 0 L 12.051 8.9 L 10.291 8.9 L 1.489 1.698 L 1.489 8.968 L 0 8.968 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					transform: "translate(73.06 0.026)",
					d: "M 11.116 0 L 0 0 L 0 1.536 L 11.116 1.536 L 11.116 0 Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					transform: "translate(73.06 4.1)",
					d: "M 0 0 L 11.116 0 L 11.116 1.47 L 1.464 1.47 L 1.464 3.341 L 11.116 3.341 L 11.116 4.81 L 0 4.81 L 0 0 Z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("text", {
			x: 458.64,
			y: 283.5,
			fontFamily: "Inter, sans-serif",
			fontWeight: 600,
			fontSize: 78.6,
			fill: "#FFFFFF",
			textLength: 840,
			lengthAdjust: "spacing",
			children: "CONCIERGE"
		})
	]
});
export default SvgPlanneConciergeLogoWhite;
